if (!customElements.get('product-tab')) {
  customElements.define(
    'product-tab',
    class ProductTab extends HTMLElement {
      constructor() {
        super();
        this.tabLinks = this.querySelectorAll('.tablinks');
        this.tabsContent = this.querySelectorAll('.tabcontent');

        for (const tabLink of this.tabLinks) {
          tabLink.addEventListener('click', this.switchTab.bind(this, tabLink));
        }
      }

      switchTab(tab) {
        for (const tabcontent of this.tabsContent) {
          tabcontent.style.display = 'none';
          if (tabcontent.id === tab.dataset.id) {
            tabcontent.style.display = 'block';
          }
        }
        for (const tabLink of this.tabLinks) {
          tabLink.classList.remove('active');
        }

        tab.classList.add('active');

      }

      connectedCallback() {
      }

      disconnectedCallback() {
      }
    }
  );
}
